// extracted by mini-css-extract-plugin
export var button = "_k-0";
export var buttonContent = "_k-e";
export var buttonGroup = "_k-c";
export var dontRestrainIconWidth = "_k-a";
export var dropdownButton = "_k-b";
export var iconContainer = "_k-9";
export var lg = "_k-4";
export var md = "_k-3";
export var pending = "_k-f";
export var sm = "_k-2";
export var spinner = "_k-d";
export var squared = "_k-8";
export var wrapText = "_k-g";
export var xl = "_k-5";
export var xs = "_k-1";
export var xxl = "_k-6";
export var xxxl = "_k-7";